module.exports = __webpack_public_path__ + "static/media/18_5.70ade965.png";